
import { defineComponent } from "vue";
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  IonPage,
  IonRouterOutlet,
  IonIcon,
} from "@ionic/vue";
import { star, informationCircle, apps,chatboxEllipsesOutline } from "ionicons/icons";
import { useBackButton, useIonRouter } from "@ionic/vue";
import { App } from "@capacitor/app";
export default defineComponent({
  name: "TabsPage",
  components: {
    IonLabel,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonPage,
    IonRouterOutlet,
    IonIcon,
  },
  setup() {
    const ionRouter = useIonRouter();
    useBackButton(-1, () => {
      if (!ionRouter.canGoBack()) {
        App.exitApp();
      }
    });

    return {
      star,
      informationCircle,
      apps,
      chatboxEllipsesOutline
    };
  },
});
